import { t as e } from "./Checkbox-DrBm0z5B.js";
import { t } from "./TextInput-64YwVFHn.js";
import n from "react";
import { Fragment as r, jsx as i, jsxs as a } from "react/jsx-runtime";
var o = {
	myocLogin: "_myocLogin_18709_9",
	overlay: "_overlay_18709_20",
	container: "_container_18709_32",
	formTilt: "_formTilt_18709_66",
	formPanel: "_formPanel_18709_75",
	imageSection: "_imageSection_18709_107",
	image: "_image_18709_107",
	imageOverlay: "_imageOverlay_18709_119",
	imageLogo: "_imageLogo_18709_131",
	onboardingTitle: "_onboardingTitle_18709_138",
	onboardingTitleHighlight: "_onboardingTitleHighlight_18709_146",
	onboardingList: "_onboardingList_18709_150",
	onboardingTick: "_onboardingTick_18709_216",
	formClose: "_formClose_18709_220",
	formBack: "_formBack_18709_243",
	formContent: "_formContent_18709_258",
	switcher: "_switcher_18709_264",
	switcherButton: "_switcherButton_18709_275",
	view: "_view_18709_288",
	viewContent: "_viewContent_18709_294",
	viewTitle: "_viewTitle_18709_306",
	field: "_field_18709_316",
	errorMessage: "_errorMessage_18709_320",
	buttonWrapper: "_buttonWrapper_18709_328",
	buttonLinks: "_buttonLinks_18709_334",
	forgottenLink: "_forgottenLink_18709_349",
	ctaButton: "_ctaButton_18709_370",
	linkButton: "_linkButton_18709_389",
	banner: "_banner_18709_405",
	bannerError: "_bannerError_18709_414",
	bannerTitle: "_bannerTitle_18709_419",
	bannerSuccess: "_bannerSuccess_18709_423",
	bannerMessage: "_bannerMessage_18709_436",
	marketingTick: "_marketingTick_18709_446",
	marketingLabel: "_marketingLabel_18709_451",
	termsCopy: "_termsCopy_18709_457",
	resetInstructions: "_resetInstructions_18709_474",
	resetConfirmation: "_resetConfirmation_18709_482",
	doneTick: "_doneTick_18709_491",
	doneMessage: "_doneMessage_18709_505",
	complianceMessage: "_complianceMessage_18709_516",
	complianceLinks: "_complianceLinks_18709_524",
	loadingSpinner: "_loadingSpinner_18709_544",
	spinner: "_spinner_18709_555",
	myocAuthSpin: "_myocAuthSpin_18709_1"
}, s = ({ label: e = "Loading…" }) => /* @__PURE__ */ a("div", {
	className: o.loadingSpinner,
	"data-testid": "myoc-auth-spinner",
	children: [/* @__PURE__ */ i("span", { className: o.spinner }), /* @__PURE__ */ i("div", { children: e })]
}), c = ({ labelActions: t, loading: r = !1, onAccept: c, privacyPolicyHref: l, termsHref: u }) => {
	let [d, f] = n.useState(!1);
	return r ? /* @__PURE__ */ i("div", {
		className: o.view,
		children: /* @__PURE__ */ i(s, {})
	}) : /* @__PURE__ */ i("div", {
		className: o.view,
		children: /* @__PURE__ */ a("div", {
			className: o.viewContent,
			children: [
				/* @__PURE__ */ i("div", {
					className: o.viewTitle,
					children: t.get("AUTH_INTRODUCTION")
				}),
				/* @__PURE__ */ i("p", {
					className: o.complianceMessage,
					children: t.get("AUTH_PLEASE_ACCEPT_OUR_POLICIES")
				}),
				/* @__PURE__ */ a("div", {
					className: o.complianceLinks,
					children: [/* @__PURE__ */ i("a", {
						href: u,
						rel: "noreferrer",
						target: "_blank",
						children: t.get("AUTH_TERMS_AND_CONDITIONS")
					}), /* @__PURE__ */ i("a", {
						href: l,
						rel: "noreferrer",
						target: "_blank",
						children: t.get("AUTH_PRIVACY_POLICY")
					})]
				}),
				/* @__PURE__ */ i(e, {
					checked: d,
					className: o.marketingTick,
					onClick: () => f((e) => !e),
					testId: "myoc-auth-compliance-accept",
					children: /* @__PURE__ */ i("span", { dangerouslySetInnerHTML: { __html: t.get("AUTH_I_HAVE_READ_TANDC_AND_PRIVACY_POLICY") } })
				}),
				/* @__PURE__ */ i("div", {
					className: o.buttonWrapper,
					children: /* @__PURE__ */ i("button", {
						className: o.ctaButton,
						disabled: !d,
						onClick: c,
						type: "button",
						children: t.get("AUTH_ACCEPT_AND_CLOSE")
					})
				})
			]
		})
	});
}, l = ({ journey: e, labelActions: t, onContinue: n }) => {
	let r = e === "signup";
	return /* @__PURE__ */ i("div", {
		className: o.view,
		children: /* @__PURE__ */ a("div", {
			className: o.viewContent,
			children: [
				/* @__PURE__ */ i("div", {
					"aria-hidden": "true",
					className: o.doneTick,
					children: "✓"
				}),
				r ? /* @__PURE__ */ i("p", {
					className: o.doneMessage,
					dangerouslySetInnerHTML: { __html: t.get("AUTH_CHECK_EMAIL") }
				}) : /* @__PURE__ */ i("p", {
					className: o.doneMessage,
					children: t.get("AUTH_THANKS_FOR_UPDATING")
				}),
				!r && /* @__PURE__ */ i("div", {
					className: o.buttonWrapper,
					children: /* @__PURE__ */ i("button", {
						className: o.ctaButton,
						onClick: n,
						type: "button",
						children: t.get("AUTH_CONTINUE_USING_ODDSCHECKER")
					})
				})
			]
		})
	});
}, u = ({ labelActions: e, resourcesUrl: t, view: n }) => {
	let r = [
		e.get("AUTH_AI_DRIVEN_TOOLS"),
		e.get("AUTH_SPORTSBOOK_COMPARISONS"),
		e.get("AUTH_EXPERT_PICKS")
	];
	return /* @__PURE__ */ i("div", {
		className: o.imageSection,
		"data-testid": "myoc-auth-image-section",
		children: /* @__PURE__ */ i("div", {
			className: o.image,
			style: { backgroundImage: `url(${t}/assets/img/myoc-login-banner.webp)` },
			children: /* @__PURE__ */ a("div", {
				className: o.imageOverlay,
				children: [n === "signup" && /* @__PURE__ */ a("div", {
					className: o.onboarding,
					children: [
						/* @__PURE__ */ i("div", {
							className: o.onboardingTitle,
							children: e.get("AUTH_NEW_SIGN_UP_REASONS")
						}),
						/* @__PURE__ */ i("div", {
							className: `${o.onboardingTitle} ${o.onboardingTitleHighlight}`,
							children: e.get("AUTH_SIGN_UP")
						}),
						/* @__PURE__ */ i("ul", {
							className: o.onboardingList,
							children: r.map((e, n) => /* @__PURE__ */ a("li", { children: [/* @__PURE__ */ i("img", {
								alt: "",
								className: o.onboardingTick,
								src: `${t}/assets/img/myoc-login-tick.svg`
							}), /* @__PURE__ */ i("span", { children: e })] }, n))
						})
					]
				}), /* @__PURE__ */ i("img", {
					alt: "Oddschecker",
					className: o.imageLogo,
					src: `${t}/assets/img/OC_LOGO_2.webp`
				})]
			})
		})
	});
}, d = ({ banner: e, resendLabel: t }) => {
	let n = e.type === "success" ? o.bannerSuccess : o.bannerError;
	return /* @__PURE__ */ a("div", {
		className: `${o.banner} ${n}`,
		"data-testid": "myoc-auth-banner",
		children: [/* @__PURE__ */ i("div", {
			className: o.bannerTitle,
			children: e.title
		}), /* @__PURE__ */ a("div", {
			className: o.bannerMessage,
			children: [e.message, e.type === "verification" && /* @__PURE__ */ i("button", {
				className: o.linkButton,
				onClick: e.onResend,
				type: "button",
				children: t
			})]
		})]
	});
}, f = (e) => /\S+@\S+\.\S+/.test(e), p = ({ banner: r, defaultEmail: c = "", fromEmailVerification: l = !1, labelActions: u, loading: p = !1, onForgotPassword: m, onSubmit: h }) => {
	let [g, _] = n.useState(c), [v, y] = n.useState(""), [b, x] = n.useState(!0), [S, C] = n.useState(!0), [w, T] = n.useState(!1), E = !S || w || r?.type === "error", D = (e) => {
		if (e.preventDefault(), !g || !v) {
			T(!0);
			return;
		}
		T(!1), h({
			email: g,
			password: v,
			rememberMe: b
		});
	};
	if (p) return /* @__PURE__ */ i("form", {
		className: o.view,
		children: /* @__PURE__ */ i(s, {})
	});
	let O = l ? "AUTH_LOGIN_TO_ODDSCHECKER_FROM_EMAIL_VERIFICATION" : "AUTH_LOGIN_TO_ODDSCHECKER";
	return /* @__PURE__ */ i("form", {
		className: o.view,
		onSubmit: D,
		children: /* @__PURE__ */ a("div", {
			className: o.viewContent,
			children: [
				/* @__PURE__ */ i("div", {
					className: o.viewTitle,
					children: u.get(O)
				}),
				/* @__PURE__ */ i(t, {
					hasError: E,
					name: "email",
					onBlur: () => C(f(g)),
					onChange: (e) => {
						_(e.target.value), T(!1);
					},
					placeholder: u.get("AUTH_INPUT_EMAIL"),
					type: "email",
					value: g,
					wrapperClassName: o.field
				}),
				!S && /* @__PURE__ */ i("div", {
					className: o.errorMessage,
					children: u.get("AUTH_EMAIL_ADDRESS_FORMAT")
				}),
				/* @__PURE__ */ i(t, {
					hasError: E,
					name: "password",
					onChange: (e) => {
						y(e.target.value), T(!1);
					},
					placeholder: u.get("AUTH_INPUT_PASSWORD"),
					type: "password",
					value: v,
					wrapperClassName: o.field
				}),
				r && /* @__PURE__ */ i(d, {
					banner: r,
					resendLabel: u.get("AUTH_RESEND_EMAIL")
				}),
				/* @__PURE__ */ a("div", {
					className: o.buttonWrapper,
					children: [/* @__PURE__ */ i("button", {
						className: o.ctaButton,
						type: "submit",
						children: u.get("AUTH_LOGIN")
					}), /* @__PURE__ */ a("div", {
						className: o.buttonLinks,
						children: [/* @__PURE__ */ i(e, {
							checked: b,
							onClick: () => x((e) => !e),
							testId: "myoc-auth-remember-me",
							children: /* @__PURE__ */ i("span", { children: u.get("AUTH_KEEP_ME_LOGGED_IN") })
						}), /* @__PURE__ */ i("button", {
							className: o.forgottenLink,
							onClick: m,
							type: "button",
							children: u.get("AUTH_FORGOT_PASSWORD")
						})]
					})]
				})
			]
		})
	});
}, m = ({ labelActions: e, loading: c = !1, onReturnToLogin: l, onSubmit: u, submitted: d = !1 }) => {
	let [p, m] = n.useState(""), [h, g] = n.useState(!0), _ = (e) => {
		e.preventDefault(), p && u(p);
	}, v = d ? e.get("AUTH_RETURN_TO_LOGIN") : e.get("AUTH_RESET_PASSWORD_ACTION");
	return /* @__PURE__ */ i("form", {
		className: o.view,
		onSubmit: d ? void 0 : _,
		children: /* @__PURE__ */ a("div", {
			className: o.viewContent,
			children: [
				/* @__PURE__ */ i("div", {
					className: o.viewTitle,
					children: e.get("AUTH_RESET_PASSWORD")
				}),
				c && /* @__PURE__ */ i(s, {}),
				!c && d && /* @__PURE__ */ i("div", {
					className: o.resetConfirmation,
					children: e.get("AUTH_RESET_PASSWORD_THANK_YOU")
				}),
				!c && !d && /* @__PURE__ */ a(r, { children: [
					/* @__PURE__ */ i("span", {
						className: o.resetInstructions,
						children: e.get("AUTH_RESET_PASSWORD_INSTRUCTIONS")
					}),
					/* @__PURE__ */ i(t, {
						hasError: !h,
						labelName: e.get("AUTH_EMAIL_ADDRESS"),
						name: "email",
						onBlur: () => g(f(p)),
						onChange: (e) => m(e.target.value),
						placeholder: e.get("AUTH_INPUT_EMAIL"),
						type: "email",
						value: p,
						wrapperClassName: o.field
					}),
					!h && /* @__PURE__ */ i("div", {
						className: o.errorMessage,
						children: e.get("AUTH_EMAIL_ADDRESS_FORMAT")
					})
				] }),
				/* @__PURE__ */ i("div", {
					className: o.buttonWrapper,
					children: /* @__PURE__ */ i("button", {
						className: o.ctaButton,
						disabled: !d && (c || !p),
						onClick: d ? l : void 0,
						type: d ? "button" : "submit",
						children: v
					})
				})
			]
		})
	});
}, h = ({ banner: r, defaultEmail: c = "", labelActions: l, loading: u = !1, onSubmit: p }) => {
	let [m, h] = n.useState(c), [g, _] = n.useState(""), [v, y] = n.useState(!0), [b, x] = n.useState(!0), [S, C] = n.useState(!1), w = !b || S || r?.type === "error";
	return u ? /* @__PURE__ */ i("form", {
		className: o.view,
		children: /* @__PURE__ */ i(s, {})
	}) : /* @__PURE__ */ i("form", {
		className: o.view,
		onSubmit: (e) => {
			if (e.preventDefault(), !m || !g) {
				C(!0);
				return;
			}
			C(!1), p({
				email: m,
				marketingConsent: v,
				password: g
			});
		},
		children: /* @__PURE__ */ a("div", {
			className: o.viewContent,
			children: [
				/* @__PURE__ */ i("div", {
					className: o.viewTitle,
					children: l.get("AUTH_SIGN_UP_TO_ODDSCHECKER")
				}),
				/* @__PURE__ */ i(t, {
					hasError: w,
					name: "email",
					onBlur: () => x(f(m)),
					onChange: (e) => {
						h(e.target.value), C(!1);
					},
					placeholder: l.get("AUTH_INPUT_EMAIL"),
					type: "email",
					value: m,
					wrapperClassName: o.field
				}),
				!b && /* @__PURE__ */ i("div", {
					className: o.errorMessage,
					children: l.get("AUTH_EMAIL_ADDRESS_FORMAT")
				}),
				/* @__PURE__ */ i(t, {
					hasError: w,
					name: "password",
					onChange: (e) => {
						_(e.target.value), C(!1);
					},
					placeholder: l.get("AUTH_INPUT_PASSWORD"),
					type: "password",
					value: g,
					wrapperClassName: o.field
				}),
				r && /* @__PURE__ */ i(d, {
					banner: r,
					resendLabel: l.get("AUTH_RESEND_EMAIL")
				}),
				/* @__PURE__ */ a("div", {
					className: o.buttonWrapper,
					children: [
						/* @__PURE__ */ i(e, {
							checked: v,
							className: o.marketingTick,
							onClick: () => y((e) => !e),
							testId: "myoc-auth-marketing-consent",
							children: /* @__PURE__ */ i("span", {
								className: o.marketingLabel,
								children: l.get("AUTH_YES_TO_MARKETING")
							})
						}),
						/* @__PURE__ */ i("button", {
							className: o.ctaButton,
							type: "submit",
							children: l.get("AUTH_SIGN_UP_CTA")
						}),
						/* @__PURE__ */ i("p", {
							className: o.termsCopy,
							dangerouslySetInnerHTML: { __html: l.get("AUTH_I_HAVE_READ_TANDC_AND_PRIVACY_POLICY") }
						})
					]
				})
			]
		})
	});
}, g = (e) => {
	let { labelActions: t } = e;
	switch (e.view) {
		case "login": return /* @__PURE__ */ i(p, {
			banner: e.loginBanner,
			defaultEmail: e.defaultEmail,
			fromEmailVerification: e.fromEmailVerification,
			labelActions: t,
			loading: e.loginLoading,
			onForgotPassword: e.onForgotPassword,
			onSubmit: e.onLoginSubmit
		});
		case "signup": return /* @__PURE__ */ i(h, {
			banner: e.signupBanner,
			defaultEmail: e.defaultEmail,
			labelActions: t,
			loading: e.signupLoading,
			onSubmit: e.onSignupSubmit
		});
		case "reset-password": return /* @__PURE__ */ i(m, {
			labelActions: t,
			loading: e.resetLoading,
			onReturnToLogin: e.onSwitchToLogin,
			onSubmit: e.onResetSubmit,
			submitted: e.resetSubmitted
		});
		case "done": return /* @__PURE__ */ i(l, {
			journey: e.doneJourney ?? "signup",
			labelActions: t,
			onContinue: e.onDoneContinue
		});
		case "compliance": return /* @__PURE__ */ i(c, {
			labelActions: t,
			loading: e.complianceLoading,
			onAccept: e.onComplianceAccept,
			privacyPolicyHref: e.privacyPolicyHref ?? "#",
			termsHref: e.termsHref ?? "#"
		});
		default: return null;
	}
}, _ = ({ labelActions: e, onSwitchToLogin: t, onSwitchToSignup: n, view: r }) => r === "login" ? /* @__PURE__ */ a("div", {
	className: o.switcher,
	children: [/* @__PURE__ */ i("span", { children: e.get("AUTH_NOT_A_MEMBER") }), /* @__PURE__ */ i("button", {
		className: o.switcherButton,
		onClick: n,
		type: "button",
		children: e.get("AUTH_SIGN_UP_NOW")
	})]
}) : r === "signup" ? /* @__PURE__ */ a("div", {
	className: o.switcher,
	children: [/* @__PURE__ */ i("span", { children: e.get("AUTH_ALREADY_A_MEMBER") }), /* @__PURE__ */ i("button", {
		className: o.switcherButton,
		onClick: t,
		type: "button",
		children: e.get("AUTH_LOGIN")
	})]
}) : null, v = (e) => {
	let { labelActions: t, onClose: r, onSwitchToLogin: s, onSwitchToSignup: c, resourcesUrl: l, view: d } = e, f = n.useRef(null);
	return n.useEffect(() => {
		let e = (e) => {
			e.key === "Escape" && r();
		};
		return document.addEventListener("keydown", e), () => document.removeEventListener("keydown", e);
	}, [r]), n.useEffect(() => {
		let e = document.activeElement;
		return (f.current?.querySelector("input, select, textarea") ?? f.current)?.focus(), () => e?.focus?.();
	}, []), /* @__PURE__ */ a("div", {
		className: o.myocLogin,
		"data-testid": "myoc-auth-modal",
		children: [/* @__PURE__ */ i("div", {
			className: o.overlay,
			onClick: r
		}), /* @__PURE__ */ a("div", {
			"aria-modal": "true",
			className: o.container,
			ref: f,
			role: "dialog",
			style: { outline: "none" },
			tabIndex: -1,
			children: [
				/* @__PURE__ */ i(u, {
					labelActions: t,
					resourcesUrl: l,
					view: d
				}),
				/* @__PURE__ */ i("button", {
					"aria-label": t.get("CLOSE"),
					className: o.formClose,
					"data-testid": "myoc-auth-close",
					onClick: r,
					type: "button",
					children: "×"
				}),
				/* @__PURE__ */ i("div", {
					className: o.formTilt,
					children: /* @__PURE__ */ a("div", {
						className: o.formPanel,
						children: [
							d === "reset-password" && /* @__PURE__ */ i("button", {
								"aria-label": "back",
								className: o.formBack,
								"data-testid": "myoc-auth-back",
								onClick: s,
								type: "button",
								children: "←"
							}),
							/* @__PURE__ */ i("div", {
								className: o.formContent,
								children: g(e)
							}),
							/* @__PURE__ */ i(_, {
								labelActions: t,
								onSwitchToLogin: s,
								onSwitchToSignup: c,
								view: d
							})
						]
					})
				})
			]
		})]
	});
};
//#endregion
export { f as a, p as i, h as n, l as o, m as r, c as s, v as t };
